import { call, put } from 'redux-saga/effects';
import _ from 'underscore';

import { requestFailed } from '~src/bootstrap/redux/actions/RequestFailedAction';
import { Messages } from '~src/codegen/Localize';
import { IPublishedConnectionDetailInfo } from '~src/publishedConnection/models/IPublishedConnectionInfo';
import { PublishedConnectionTaskTableInfo } from '~src/publishedConnection/types/PublishedConnectionTaskTableInfo';
import { PublishedConnectionTables } from '~src/publishedConnectionTable/resources/PublishedConnectionTables';
import { IPublishedConnectionTable } from '~src/publishedConnectionTable/serverApi/types/IPublishedConnectionTable';
import { IContentInfo } from '~src/spacesPlatform/models/IContentInfo';

import { PublishedConnectionTableExtractsRefreshNowAction } from '../actions/PublishedConnectionTableExtractsRefreshNowAction';
import { openPublishedConnectionTableRefreshNowDialogDialog } from '../components/PublishedConnectionTableExtractsRefreshNowDialog';

function allItemsFromSamePublishedConnection(targetItems: IContentInfo[]): boolean {
  if (targetItems.length >= 1) {
    const publishedConnectionId = (targetItems[0] as unknown as IPublishedConnectionTable).publishedConnectionId;
    return _.all(targetItems, (item => (item as unknown as IPublishedConnectionTable).publishedConnectionId === publishedConnectionId));
  }
  return false;
}

export function* handlePublishedConnectionTableRefreshNowExtract(action: PublishedConnectionTableExtractsRefreshNowAction) {
  const { selectedContent } = action;
  if (action.selectedContent.length === 0) {
    return;
  }

  const publishedConnectionId = (selectedContent[0] as unknown as IPublishedConnectionTable).publishedConnectionId;
  if (!publishedConnectionId || !allItemsFromSamePublishedConnection(selectedContent)) {
    // all content should be from same pconn
    yield call(PublishedConnectionTables.popError, Messages.publishedConnectionTableExtractsRefreshNowError());
  }

  const selectedTables = (action.selectedContent as unknown as IPublishedConnectionDetailInfo[]);
  const selectedExtractedTables = selectedTables.filter(table => table.hasExtracts === true);

  const tables: ReadonlyArray<PublishedConnectionTaskTableInfo> = selectedExtractedTables.map(item => ({
    alias: item.name,
    luid: item.luid,
  }));

  try {
    yield call(openPublishedConnectionTableRefreshNowDialogDialog, publishedConnectionId, tables);
  } catch (e) {
    yield put(requestFailed(e, Messages.unexpectedError()));
  }
}
